import { useEffect } from "react";
import { useAppStore } from "@/state/appStore";

const borderByKind = {
  success: "var(--status-success)",
  warning: "var(--status-warning)",
  error: "var(--status-blocker)",
  info: "var(--status-info)"
};

export const ToastHost = (): JSX.Element => {
  const toasts = useAppStore((state) => state.toasts);
  const dismissToast = useAppStore((state) => state.dismissToast);

  useEffect(() => {
    const timers = toasts
      .filter((toast) => !toast.persistent)
      .map((toast) =>
        window.setTimeout(() => {
          dismissToast(toast.id);
        }, toast.kind === "warning" ? 6000 : 4000)
      );

    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [toasts, dismissToast]);

  return (
    <div className="pointer-events-none fixed bottom-24 left-1/2 z-[90] flex w-[calc(100%-32px)] max-w-[398px] -translate-x-1/2 flex-col gap-2">
      {toasts.slice(0, 3).map((toast) => (
        <div
          key={toast.id}
          className="pointer-events-auto rounded-xl border bg-[var(--bg-elevated)] p-3 text-sm shadow-lg"
          style={{ borderColor: borderByKind[toast.kind], borderLeftWidth: 4 }}
          role="status"
          aria-live="polite"
        >
          <div className="flex items-start justify-between gap-2">
            <span>{toast.message}</span>
            <button
              type="button"
              className="btn btn-ghost !min-h-0 !p-0 text-xs"
              onClick={() => dismissToast(toast.id)}
              aria-label="Dismiss notification"
            >
              Dismiss
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
